import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [CommonModule, MaterialModule, TranslateModule, RouterModule],
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent {
  @Input() title: string = 'LABEL.NO_DATA';
  @Input() description: string = '';
  @Input() icon: string = 'inbox';
  @Input() btnName: string = '';
  @Input() btnSubName: string = '';
  @Input() btnIcon: string = 'add';
  @Input() btnLink?: string | unknown[];

  @Output() action = new EventEmitter<void>();

  onAction() {
    this.action.emit();
  }
}
